import {
  MOBILE_PROFILES,
  getMobileAppProfile,
  canAccessDefectSheetsMobile,
  canAccessQuotationsMobile,
  hasMobilePermission,
} from './mobileProfile'

export const MOBILE_WEB_MAX_WIDTH = 768

export function isMobileWebViewport() {
  if (typeof window === 'undefined') return false
  return window.matchMedia(`(max-width: ${MOBILE_WEB_MAX_WIDTH}px)`).matches
}

/** Admin accounts use mobile_app_profile when viewed on a narrow viewport. */
export function appliesMobileProfile(user, isMobileWeb = isMobileWebViewport()) {
  return isMobileWeb && Number(user?.role_id) === 1
}

export function getMobileWebDefaultRoute(user) {
  const profile = getMobileAppProfile(user)
  if (profile === MOBILE_PROFILES.NONE || profile === MOBILE_PROFILES.SALES) {
    return '/mobile/dashboard'
  }
  return '/painter/dashboard'
}

function pathMatches(pathname, allowed) {
  if (allowed instanceof RegExp) return allowed.test(pathname)
  return pathname === allowed
}

export function getAllowedMobileWebPaths(user) {
  const profile = getMobileAppProfile(user)

  if (profile === MOBILE_PROFILES.NONE) {
    return ['/mobile/dashboard']
  }

  if (profile === MOBILE_PROFILES.SALES) {
    const paths = ['/mobile/dashboard']
    if (canAccessQuotationsMobile(user)) paths.push('/jobs/quotations')
    if (canAccessDefectSheetsMobile(user)) {
      paths.push('/jobs/defect-sheets', /^\/jobs\/defect-sheets\/\d+/)
    }
    return paths
  }

  const paths = [
    '/painter/dashboard',
    '/painter/stock',
    '/painter/record-usage',
    '/painter/search',
    '/painter/transfer',
    '/painter/request',
    '/painter/my-requests',
    '/painter/monthly-restock',
    '/painter/monthly-restock/new',
    '/painter/movements',
    '/painter/alerts',
  ]

  if (hasMobilePermission(user, 'purchase_orders')) {
    paths.push('/painter/purchase-orders')
  }
  if (hasMobilePermission(user, 'field_jobs')) {
    paths.push('/worker/jobs', /^\/worker\/jobs\/\d+/)
  }
  if (hasMobilePermission(user, 'field_hours')) {
    paths.push('/worker/hours')
  }
  if (canAccessDefectSheetsMobile(user)) {
    paths.push('/jobs/defect-sheets', /^\/jobs\/defect-sheets\/\d+/)
    paths.push(/^\/jobs\/\d+\/defect-sheet/)
  }

  return paths
}

export function isPathAllowedOnMobileWeb(user, pathname) {
  if (!appliesMobileProfile(user)) return true
  const allowed = getAllowedMobileWebPaths(user)
  return allowed.some((entry) => pathMatches(pathname, entry))
}

export function getMobileWebRoleLabel(user) {
  const profile = getMobileAppProfile(user)
  if (profile === MOBILE_PROFILES.SALES) return 'Sales'
  if (profile === MOBILE_PROFILES.NONE) return 'Web only'
  return 'Field'
}
